import Container from 'components/Container';
import React from 'react';

export default function NotFoundPage() {
  return (
    <Container>
      <h1>404 Not Found Page :(</h1>
    </Container>
  );
}
